<template>
  <div :class="containerClass">
    <label v-if="label" class="form-label" :class="labelClass">
      <span :class="required ? 'required' : ''">{{ label }}</span>
    </label>
    <div
        ref="editorRef"
        :id="id"
    >
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, defineProps, defineEmits, defineModel } from "vue";
import { useI18n } from "vue-i18n";

const model = defineModel()

const props = defineProps({
  id: String,
  label: String,
  labelClass: String,
  required: Boolean,
  containerClass: { type: String, default: 'h-400px' },
  disabled: { type: Boolean, default: false },
  parentId: String,
  withImage: {
    type: Boolean,
    default: true
  },

});

const imageToolBarItems = ref(["|", "imageUpload",'imageResize'])
const editorRef = ref(null);
let editorInstance = null;
const emits = defineEmits(["text", "ready"]);
const { t } = useI18n({ useScope: 'global' })

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return {
      upload() {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          loader.file
              .then(file => {
                reader.readAsDataURL(file);
                reader.onload = () => resolve({ default: reader.result });
                reader.onerror = error => reject(error);
              });
        });
      },
      abort() {}
    };
  };
}

watch(() => props.id, (value) => {
  if(value) {
    initCKEditor()
  }
});

watch(() => model.value, (newValue) => {
  if (editorInstance && newValue !== null && newValue !== undefined && editorInstance.getData().trim() !== newValue.trim()) {
    editorInstance.setData(newValue);
  }
});

watch(() => props.disabled, (isDisabled) => {
  if (editorInstance) {
    editorInstance.isReadOnly = isDisabled;
  }
});


function initCKEditor() {
  if (window.ClassicEditor) {
    ClassicEditor
        .create(editorRef.value, {
          extraPlugins: [MyCustomUploadAdapterPlugin],
          resize_enabled: false,
          fullPage: false,
          allowedContent: true,
          toolbar: {items:[
              "heading", "bold", "italic", "underline", "strikethrough",
              "fontSize", "fontFamily", "fontColor", "fontBackgroundColor",
              "|", "alignment", "outdent", "indent",
              "|", "bulletedList", "numberedList", "todoList",
              "|", "blockQuote", "insertTable",
              ...(props.withImage ? imageToolBarItems.value : []),
              "|", "removeFormat", "sourceEditing",
              "|", "undo", "redo",
            ], shouldNotGroupWhenFull: true},
          readOnly: props.disabled,
          styles: {
            options: [
              {
                name: 'Citation',
                element: 'blockquote',
                classes: 'custom-blockquote'
              }
            ]
          },


          htmlSupport: {
            allow: [
              {
                name: /^(iframe|object|embed)$/,
                attributes: true,
                classes: true,
                styles: true
              }
            ]
          }
        })
        .then(editor => {
          editorInstance = editor;

          if(model.value) {
            editor.setData(model.value);
          }

          editor.model.document.on("change:data", () => {
            model.value = editor.getData();
          });

          emits("ready", editorInstance);

          if (props.parentId) {
            $(props.parentId).modal({
              backdrop: 'static',
              keyboard: false,
              focus: false
            })
          }



        })
        .catch(error => console.error("CKEditor Error:", error));

  }
}

onMounted(() => {
  initCKEditor()
});


</script>

<style>

.ck.ck-editor__editable figure figcaption {
  display: none !important;
}
.ck.ck-balloon-panel {
  z-index: 9999 !important;
}
.ck.ck-editor {
  height: 100%!important;
  max-height: 100%!important;
  z-index: 1 !important;
}

.ck .ck-content {
  height: 90%;
  max-height: 90%!important;
  overflow-y: auto !important;
}

.ck .ck-editor__main {
  height: 75% !important;
}

.ck .ck-editor__top {
  position: sticky;
  top: 0;
  border-bottom: 1px solid #eff2f5;
}

.ck-editor .ck-focused {
  border: 1px solid #eff2f5 !important;
}

.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border: 1px solid #eff2f5;
}


.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  line-height: var(--ck-powered-by-line-height);
  display: none !important;
}

.ck.ck-toolbar {
  background: var(--ck-color-toolbar-background);
  border: 1px solid #eff2f5;
  padding: 0 var(--ck-spacing-small);
}

.ck.ck-balloon-rotator {
  z-index: 188888 !important;
}



</style>

